<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="ch00_fm05_ded"></a><a id="page_v"></a><em>For the students of Barbara Jordan</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_ded.vue?525e6fce